var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoardOutlinedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64263 6.53755H6.00964V15.2128H7.64263V6.53755Z",
    fill: "#393941"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9086 6.53755H9.27563V10.8752H10.9086V6.53755Z",
    fill: "#393941"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1746 6.53755H12.5416V13.4778H14.1746V6.53755Z",
    fill: "#393941"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8076 3.06744H4.37665C3.4785 3.06744 2.74365 3.84822 2.74365 4.8025V16.9479C2.74365 17.9022 3.4785 18.6829 4.37665 18.6829H15.8076C16.7057 18.6829 17.4406 17.9022 17.4406 16.9479V4.8025C17.4406 3.84822 16.7057 3.06744 15.8076 3.06744ZM15.8076 16.9479H4.37665V4.8025H15.8076V16.9479Z",
    fill: "#393941"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardOutlinedIcon);
export default __webpack_public_path__ + "static/media/board_outlined_icon.8a727003.svg";
export { ForwardRef as ReactComponent };